import { createFileRoute } from '@tanstack/react-router'
import { InvitationPage } from '~/features/auth/InvitationPage'
import { invitationQuery } from '~/features/auth/queries'

export const Route = createFileRoute('/einladung/$token')({
  // Warm the cache; an invalid link renders its own state instead of the error page.
  loader: ({ context, params }) => void context.queryClient.prefetchQuery(invitationQuery(params.token)),
  component: function Invitation() {
    return <InvitationPage token={Route.useParams().token} />
  },
})
